/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';
import api from "../../../../services/api";
import {
    Button, Modal, Container, Row, Col, Input, FormGroup
} from "reactstrap";
import { DropdownBox } from "../../../dropdowns";
import { DatePicker } from "../../../date-pickers";
import Loader from "../../../loaders";
import { formatDate, formatDateZeroTime } from "../../../../utils";
import _ from 'lodash';
import { useEffect } from 'react';
import { MakeWords } from '../../../../helpers/StringHelper';
import { useMemo, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

function BulkMilestoneEditor(props) {
    const {
        candidates,
        jobOrderCandidates = [],
        setPdrsRequest,
        setMilestoneDocumentRequest
    } = props;

    const [bulkMilestone, setBulkMilestone] = React.useState({ jobOrderCandidateIds: candidates.filter(f => !!f.candidateId), jobOrderMilestoneId: null, milestoneName: "" });
    const [loading, setLoading] = React.useState(false);
    const [milestones, setMilestones] = React.useState([]);
    const [ignoredRosterSlotNo, setIgnoredRosterSlotNo] = React.useState([]);
    const [validation, setValidation] = useState(null);
    const [uploadedMilestoneDocument, setUploadedMilestoneDocument] = useState(null);
    const [refreshCheckMilestone, setRefreshCheckMilestone] = useState(null);
    const ignoredRosterSlotNoStr = useMemo(() => {
        if (!ignoredRosterSlotNo?.length) return "";
        return MakeWords(ignoredRosterSlotNo);
    }, [ignoredRosterSlotNo]);

    useEffect(() => {
        if (!jobOrderCandidates?.length) {
            setIgnoredRosterSlotNo([]);
            return;
        }

        var jocNoCandidate = jobOrderCandidates.filter(f => !f.candidateId);
        var ignoredRosterSlotNo = jocNoCandidate.map(m => m.rosterCandidate ? (m.rosterCandidate.relatedRosterCandidateId ? `${m.rosterCandidate.relatedRosterCandidateNumber}.${m.rosterCandidate.rosterCandidateNumber}` : `${m.rosterCandidate.rosterCandidateNumber}`) : null);
        setIgnoredRosterSlotNo(ignoredRosterSlotNo);
        setBulkMilestone({ ...bulkMilestone, jobOrderCandidates: jobOrderCandidates.filter(f => f.candidateId), jobOrderCandidateIds: jobOrderCandidates.filter(f => f.candidateId).map(m => m.jobOrderCandidateId) });
    }, [candidates, jobOrderCandidates]);

    useEffect(() => {
        if (!refreshCheckMilestone)
            return;

        checkMilestone(refreshCheckMilestone.isAlreadySentMessage, refreshCheckMilestone.isAlreadyUploadDocument);
        setRefreshCheckMilestone(null);
    }, [refreshCheckMilestone]);

    useEffect(() => {
        if (props.jobOrderId > 0) {
            setLoading(true);

            let apiCalls = [
                api.get(`jobordercandidate/milestones/${props.jobOrderId}`), // 0
                //api.get(`/messagesmaster?${qs.stringify({ filters: [{ id: "title", value: "Applicant Pack Sent" }] }, { allowDots: true })}`), // 1
            ];

            Promise.all(apiCalls)
                .then((response) => {
                    setMilestones(response[0].data);
                    //setApplicantPackSentMessage(response[1].data.data[0]);
                })
                .catch((error) => console.error(error))
                .finally(() => setLoading(false));
        }
    }, []);

    const handleSelectedMilestoneChanged = useCallback((item) => {
        setBulkMilestone({
            ...bulkMilestone,
            jobOrderMilestoneId: item ? item.jobOrderMilestoneId : null,
            jobOrderMilestoneMasterId: item ? item.jobOrderMilestoneMasterId : null,
            milestoneName: item ? item.milestoneName : "",
            orderingIndex: item ? item.orderingIndex : null,
            requireSms: item ? item.requireSms : null,
            needDocument: item ? item.needDocument : null,
        });
    }, [bulkMilestone]);

    const handleTextChanged = useCallback(({ target: { name, value } }) => {
        setBulkMilestone({ ...bulkMilestone, [name]: value });
    }, [bulkMilestone]);

    const handleDateChanged = useCallback((value, name) => {
        setBulkMilestone({
            ...bulkMilestone,
            [name]: !value ? null : formatDateZeroTime(value)
        });
    }, [bulkMilestone]);

    const handleSave = useCallback((completed = false) => {
        setLoading(true);
        
        api.post(`jobordercandidate/bulkmilestone?completed=${completed}`, JSON.stringify(bulkMilestone))
            .then((response) => {
                if (!uploadedMilestoneDocument)
                {
                    setLoading(false);
                    props.onSaved();
                    return;
                }

                const formData = new FormData();
                for (let i = 0; i < response.data.jobOrderCandidateMilestoneIds.length; i++) {
                    const currentData = response.data.jobOrderCandidateMilestoneIds[i];
                    console.log({currentData, uploadedMilestoneDocument});
                    formData.append(`[${i}].jobOrderCandidateMilestoneId`, currentData);
                    formData.append(`[${i}].file`, uploadedMilestoneDocument);
                }

                const url = `${process.env.REACT_APP_WEB_API_BASE_URI}/jobordercandidate/newmiledocument`;
                const method = "POST";
        
                api({
                    url,
                    method,
                    data: formData,
                })
                    .then(() => props.onSaved())
                    .catch((error) => console.error({error}))
                    .finally(() => {
                        if (uploadedMilestoneDocument)
                            setUploadedMilestoneDocument(null);

                        setLoading(false);
                    })
                ;
            })
            .catch((error) => {
                console.error(error);

                if (uploadedMilestoneDocument)
                    setUploadedMilestoneDocument(null);

                setLoading(false);
            })
        ;
    }, [bulkMilestone, uploadedMilestoneDocument]);

    const checkMilestone = useCallback((isAlreadySentMessage = false, isAlreadyUploadDocument = false) => {
        if (!bulkMilestone?.milestoneName) {
            setValidation({
                title: `Bulk Milestone Editor`,
                message: "Please select the Milestone Progress Update from the list."
            });
            return;
        }

        if (!bulkMilestone?.milestoneDate) {
            setValidation({
                title: `Bulk Milestone Editor`,
                message: "Please enter the Milestone Date."
            });
            return;
        }

        if (!milestones.length || !bulkMilestone?.jobOrderMilestoneId)
            return;

        const latestMilestoneId = milestones[milestones.length - 1].jobOrderMilestoneId;

        if (!isAlreadyUploadDocument && bulkMilestone?.needDocument)
        {
            setMilestoneDocumentRequest({
                jobOrderCandidates: bulkMilestone.jobOrderCandidates,
                onSubmit: (submittedData) => {
                    if (submittedData?.file)
                        setUploadedMilestoneDocument(submittedData?.file);

                    setMilestoneDocumentRequest(null);
                    setRefreshCheckMilestone({
                        isAlreadySentMessage,
                        isAlreadyUploadDocument: submittedData?.file ? true : false,
                    });
                },
                milestoneName: bulkMilestone.milestoneName,
            })
            return;
        }

        if (!isAlreadySentMessage && bulkMilestone?.requireSms == true) {
            const name = bulkMilestone?.milestoneName == null ? '' : bulkMilestone?.milestoneName.trim();
            setLoading(true);

            api.get(`/messagesmaster/milestone/${bulkMilestone.jobOrderMilestoneMasterId}`)
                .then((response) => {
                    if (!response.data) {
                        setLoading(false);
                        setValidation({
                            title: `Bulk Milestone Editor`,
                            message: `Milestone ${name} requires a message master template, which is not found. To continue, please open Maintenance -> Job Order Milestone Master -> Edit ${name} -> Pick a message template -> Save.`
                        });
                        return;
                    }

                    const newPdrsRequest = {
                        milestoneName: name,
                        jobOrderCandidateId: null,
                        jobOrderId: null,
                        projectId: null,
                        candidateId: null,
                        itemSMS: [...jobOrderCandidates],
                        defaultMessage: response.data,
                        onSaved: (isSuccess = true) => {
                            checkMilestone(isSuccess);
                        }
                    };
                    
                    setLoading(false);
                    setPdrsRequest(newPdrsRequest);
                })
                .catch((error) => {
                    setLoading(false);
                    setValidation({
                        title: `Bulk Milestone Editor`,
                        message: `Unexpected error.`
                    });
                    console.error(error);
                })
            ;

            return;
        }

        if (latestMilestoneId !== bulkMilestone.jobOrderMilestoneId) {
            handleSave();
            return;
        }

        handleSave(true);
    }, [bulkMilestone, milestones, jobOrderCandidates, uploadedMilestoneDocument, handleSave]);

    return <Modal
        isOpen={true}
        className="modal-lg"
        modalClassName="db-example-modal-lg"
    >
        <div className="modal-header">
            <h5 className="modal-title">Bulk Milestone Update</h5>
            <button
                aria-label="Close"
                className="close"
                onClick={props.onClose}
                type="button"
            >
                <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
            </button>
        </div>
        <div className="modal-body">
            <Container fluid className="px-0">
                {(loading) && <Loader />}
                {!!ignoredRosterSlotNo?.length &&
                    <Row>
                        <Col xs={12}>
                            <div className="alert alert-danger">Roster Slot with no associated candidate will be ignored. Please check Roster Slot No. {ignoredRosterSlotNoStr}</div>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col xs={12} sm={6} className="pr-1">
                        <FormGroup>
                            <DropdownBox
                                data={milestones}
                                idField="jobOrderMilestoneId"
                                valueField="milestoneName"
                                selectedItem={bulkMilestone}
                                onChange={(item) => {
                                    handleSelectedMilestoneChanged(item);
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12} sm={6} className="pl-2">
                        <FormGroup>
                            <DatePicker
                                name="milestoneDate"
                                id="milestoneDate"
                                type="text"
                                required
                                value={formatDate(bulkMilestone == null ? "" : bulkMilestone.milestoneDate)}
                                onChange={handleDateChanged}
                                closeOnSelect
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12} sm={12}>
                        <FormGroup>
                            <Input
                                name="milestoneNote"
                                id="milestoneNote"
                                type="textarea"
                                placeholder="Milestone Note"
                                rows={8}
                                value={bulkMilestone == null ? "" : bulkMilestone.milestoneNote}
                                onChange={handleTextChanged}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Button
                                color="primary"
                                onClick={() => {
                                    checkMilestone();
                                }}
                                type="button">
                                Submit Progress <i className="fas fa-caret-right ml-2"></i>
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </Container>
        </div>
        <div
            className="modal-footer"
        >
            <Button
                color="secondary"
                onClick={() => {
                    props.onClose()
                }}
                type="button"
            >
                Close
            </Button>
        </div>

        {
            validation ?
                <SweetAlert
                    title={validation.title}
                    error
                    confirmBtnText="OK"
                    confirmBtnBsStyle="danger"
                    onConfirm={() => setValidation(null)}
                >
                    {validation.message}
                </SweetAlert>
                :
                null
        }
    </Modal>
}

export default BulkMilestoneEditor;
